export default __webpack_public_path__ + "static/media/olva-kapak.b5cd08c8.jpg";